module.exports = __webpack_public_path__ + "img/Speaker=Alex Ng.9bf65a97.png";